import { useState } from "react";

import MeasuresExportButton from "components/atoms/MeasuresExportButton/MeasuresExportButton";
import ViewTab from "components/atoms/ViewTab";
import FiltersSidebar from "components/organisms/FiltersSidebar";

import SearchBar from "components/organisms/SearchBar/SearchBar";
import { useResetRecoilState } from "recoil";
import { tableStateFamily } from "recoilStore/Table/useTableState";
import { TABLE_IDS } from "utils/constants";
import { getTableIdFromSelection } from "utils/helpers";
import MeasuresMeasuresReport from "./MeasuresMeasuresReport";
import "./MeasuresPage.scss";
import MeasuresProjectsReport from "./MeasuresProjectsReport";

function MeasuresPage({ filtersetUid, reportedVsPublished }: { filtersetUid: string; reportedVsPublished: string }) {
    const [currentActiveTab, setCurrentActiveTab] = useState<MeasuresTab>("projects");

    const [filterSidebarIsOpen, setFilterSidebarIsOpen] = useState(false);

    const [exportProjectsData, setExportProjectsData] = useState([]);
    const [exportMeasuresData, setExportMeasuresData] = useState([]);

    const resetMeasuresProjectsTable = useResetRecoilState(tableStateFamily(TABLE_IDS.MEASURES_PROJECTS));
    const resetMeasuresMeasuresTable = useResetRecoilState(tableStateFamily(TABLE_IDS.MEASURES_MEASURES));

    const tabClickHandler = (tabName: MeasuresTab) => {
        setCurrentActiveTab(tabName);
        resetMeasuresProjectsTable();
        resetMeasuresMeasuresTable();
    };

    const exportData = {
        projects: {
            data: exportProjectsData,
        },
        measures: {
            data: exportMeasuresData,
        },
    };

    const currentTableId = getTableIdFromSelection(currentActiveTab, TABLE_IDS.MEASURES_PROJECTS);

    return (
        <div className="measures-page">
            <div className="measures-page--view-tabs">
                <div className="measures-page--view-tabs">
                    <SearchBar tableId={currentTableId} />

                    <ViewTab
                        id="measures-projects-tab"
                        name="All measures"
                        selected={currentActiveTab === "projects"}
                        onClick={() => tabClickHandler("projects")}
                    />
                    <ViewTab
                        id="measures-measures-tab"
                        name="Grouped by name"
                        selected={currentActiveTab === "measures"}
                        onClick={() => tabClickHandler("measures")}
                    />
                </div>
                <div className="measures-page-filter-with-export">
                    <MeasuresExportButton
                        data={exportData[currentActiveTab].data}
                        currentActiveTab={currentActiveTab}
                    />
                </div>
            </div>
            <FiltersSidebar closeSidebar={() => setFilterSidebarIsOpen(false)} sidebarOpen={filterSidebarIsOpen} />

            {currentActiveTab === "projects" && (
                <MeasuresProjectsReport
                    setExportData={setExportProjectsData}
                    filtersetUid={filtersetUid}
                    reportedVsPublished={reportedVsPublished}
                />
            )}

            {currentActiveTab === "measures" && (
                <MeasuresMeasuresReport
                    setExportData={setExportMeasuresData}
                    filtersetUid={filtersetUid}
                    reportedVsPublished={reportedVsPublished}
                />
            )}
        </div>
    );
}

export default MeasuresPage;
